import parseUrl from "./parseUrl";

const parse = (urlOrUri = '') =>
parseUrl((urlOrUri.indexOf('http') !== 0 ? 'http://dummy.domain?' : '') + (urlOrUri[0] === '?' ? urlOrUri.substr(1) : urlOrUri))
    .query;

export default parse;